var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['knowledge-card', _vm.sideClass],style:(_vm.customStyle),attrs:{"id":_vm.id},on:{"mouseenter":function($event){return _vm.addGlowing()},"mouseleave":function($event){return _vm.removeGlowing()}}},[_c('img',{staticClass:"animate-on-hover-2",attrs:{"src":_vm.icon,"height":"55"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }